import Mailcheck from 'mailcheck';

Mailcheck.defaultDomains.push(
  'yandex.ru',
);

const check = email => new Promise(accept => {
  Mailcheck.run({
    email,
    suggested: accept,
    empty: accept,
  });
});

export default check;
